module.exports = __webpack_public_path__ + "static/media/writer.029f2e71.jpg";